import React from "react";
import { PageHeader } from "./PageHeader"
import {DataBox} from "./DataBox"
const BaseItem = () => {
    return (
        <>
            <PageHeader/>
            <DataBox/>
        </>
    )
}
export default BaseItem